// JS
import React from 'react';

// SIZES DATA - COUNTRIES & BRANDS
const sizeClothingUK = () => {
  return (
    <div className="size-guide-clothing">
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Mens Outerwear</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Size</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>Centermeters (CM)</strong>
            </td>
            <td>86/89</td>
            <td>90/96</td>
            <td>98/102</td>
            <td>104/109</td>
            <td>112/117</td>
            <td>119/123</td>
          </tr>
          <tr>
            <td>
              <strong>Inches</strong>
            </td>
            <td>35/36</td>
            <td>37/38</td>
            <td>39/40</td>
            <td>41/42</td>
            <td>43/44</td>
            <td>45/46</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Mens Tops</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Size</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>Centermeters (CM)</strong>
            </td>
            <td>86/89</td>
            <td>90/96</td>
            <td>98/102</td>
            <td>104/109</td>
            <td>112/117</td>
            <td>118/123</td>
          </tr>
          <tr>
            <td>
              <strong>Inches</strong>
            </td>
            <td>35/36</td>
            <td>37/38</td>
            <td>39/40</td>
            <td>41/42</td>
            <td>43/44</td>
            <td>45/46</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Mens Bottoms</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Size</strong>
            </td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
          </tr>
          <tr>
            <td>
              <strong>Centermeters (CM)</strong>
            </td>
            <td>79/81</td>
            <td>84/86</td>
            <td>89/91</td>
            <td>94/97</td>
          </tr>
          <tr>
            <td>
              <strong>Inches</strong>
            </td>
            <td>31/32</td>
            <td>33/34</td>
            <td>35/36</td>
            <td>37/38</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th colSpan="10">
              <p>Fitted Caps</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Cap</strong>
            </td>
            <td>6⅞</td>
            <td>7</td>
            <td>7⅛</td>
            <td>7⅜</td>
            <td>7½</td>
            <td>7⅝</td>
            <td>7¾</td>
            <td>8⅞</td>
          </tr>
          <tr>
            <td>
              <strong>Centermeters (CM)</strong>
            </td>
            <td>79/81</td>
            <td>84/86</td>
            <td>89/91</td>
            <td>94/97</td>
            <td>79/81</td>
            <td>84/86</td>
            <td>89/91</td>
            <td>94/97</td>
          </tr>
          <tr>
            <td>
              <strong>Inches</strong>
            </td>
            <td>31/32</td>
            <td>33/34</td>
            <td>35/36</td>
            <td>37/38</td>
            <td>31/32</td>
            <td>33/34</td>
            <td>35/36</td>
            <td>37/38</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const sizeClothingJapan = () => {
  return (
    <div className="size-guide-clothing">
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Mens Outerwear</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Japanese</strong>
            </td>
            <td>0</td>
            <td>1</td>
            <td>2</td>
            <td>3</td>
            <td>4</td>
            <td>5</td>
          </tr>
          <tr>
            <td>
              <strong>Size</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>Centermeters (CM)</strong>
            </td>
            <td>86/89</td>
            <td>90/96</td>
            <td>98/102</td>
            <td>104/109</td>
            <td>112/117</td>
            <td>119/123</td>
          </tr>
          <tr>
            <td>
              <strong>Inches</strong>
            </td>
            <td>35/36</td>
            <td>37/38</td>
            <td>39/40</td>
            <td>41/42</td>
            <td>43/44</td>
            <td>45/46</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Mens Tops</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Japanese</strong>
            </td>
            <td>0</td>
            <td>1</td>
            <td>2</td>
            <td>3</td>
            <td>4</td>
            <td>5</td>
          </tr>
          <tr>
            <td>
              <strong>Size</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>Centermeters (CM)</strong>
            </td>
            <td>86/89</td>
            <td>90/96</td>
            <td>98/102</td>
            <td>104/109</td>
            <td>112/117</td>
            <td>118/123</td>
          </tr>
          <tr>
            <td>
              <strong>Inches</strong>
            </td>
            <td>35/36</td>
            <td>37/38</td>
            <td>39/40</td>
            <td>41/42</td>
            <td>43/44</td>
            <td>45/46</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Mens Bottoms</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Japanese</strong>
            </td>
            <td>0</td>
            <td>1</td>
            <td>2</td>
            <td>3</td>
            <td>4</td>
            <td>5</td>
          </tr>
          <tr>
            <td>
              <strong>Size</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>Centermeters (CM)</strong>
            </td>
            <td>73/76</td>
            <td>77/80</td>
            <td>81/84</td>
            <td>84/86</td>
            <td>87/90</td>
            <td>91/94</td>
          </tr>
          <tr>
            <td>
              <strong>Inches</strong>
            </td>
            <td>28/29</td>
            <td>30/31</td>
            <td>32/33</td>
            <td>33/34</td>
            <td>35/36</td>
            <td>37/38</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th colSpan="10">
              <p>Fitted Caps</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Cap</strong>
            </td>
            <td>6⅞</td>
            <td>7</td>
            <td>7⅛</td>
            <td>7⅜</td>
            <td>7½</td>
            <td>7⅝</td>
            <td>7¾</td>
            <td>8⅞</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>
              <strong>Centermeters (CM)</strong>
            </td>
            <td>79/81</td>
            <td>84/86</td>
            <td>89/91</td>
            <td>94/97</td>
            <td>79/81</td>
            <td>84/86</td>
            <td>89/91</td>
            <td>94/97</td>
            <td>94/97</td>
          </tr>
          <tr>
            <td>
              <strong>Inches</strong>
            </td>
            <td>31/32</td>
            <td>33/34</td>
            <td>35/36</td>
            <td>37/38</td>
            <td>31/32</td>
            <td>33/34</td>
            <td>35/36</td>
            <td>37/38</td>
            <td>37/38</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const sizeClothingEU = () => {
  return (
    <div className="size-guide-clothing">
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Mens Outerwear</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>European</strong>
            </td>
            <td>44</td>
            <td>46</td>
            <td>48</td>
            <td>50</td>
            <td>52</td>
            <td>54</td>
          </tr>
          <tr>
            <td>
              <strong>Size</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>Centermeters (CM)</strong>
            </td>
            <td>86/89</td>
            <td>90/96</td>
            <td>98/102</td>
            <td>104/109</td>
            <td>112/117</td>
            <td>119/123</td>
          </tr>
          <tr>
            <td>
              <strong>Inches</strong>
            </td>
            <td>35/36</td>
            <td>37/38</td>
            <td>39/40</td>
            <td>41/42</td>
            <td>43/44</td>
            <td>45/46</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Mens Tops</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>European</strong>
            </td>
            <td>44</td>
            <td>46</td>
            <td>48</td>
            <td>50</td>
            <td>52</td>
            <td>54</td>
          </tr>
          <tr>
            <td>
              <strong>Size</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>Centermeters (CM)</strong>
            </td>
            <td>86/89</td>
            <td>90/96</td>
            <td>98/102</td>
            <td>104/109</td>
            <td>112/117</td>
            <td>118/123</td>
          </tr>
          <tr>
            <td>
              <strong>Inches</strong>
            </td>
            <td>35/36</td>
            <td>37/38</td>
            <td>39/40</td>
            <td>41/42</td>
            <td>43/44</td>
            <td>45/46</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Mens Bottoms</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>European</strong>
            </td>
            <td>44</td>
            <td>46</td>
            <td>48</td>
            <td>50</td>
            <td>52</td>
            <td>54</td>
          </tr>
          <tr>
            <td>
              <strong>Size</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>Centermeters (CM)</strong>
            </td>
            <td>68/72</td>
            <td>73/76</td>
            <td>77/80</td>
            <td>81/84</td>
            <td>87/90</td>
            <td>91/94</td>
          </tr>
          <tr>
            <td>
              <strong>Inches</strong>
            </td>
            <td>26/27</td>
            <td>28/29</td>
            <td>30/31</td>
            <td>32/33</td>
            <td>33/34</td>
            <td>35/36</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th colSpan="10">
              <p>Fitted Caps</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Cap</strong>
            </td>
            <td>6⅞</td>
            <td>7</td>
            <td>7⅛</td>
            <td>7⅜</td>
            <td>7½</td>
            <td>7⅝</td>
            <td>7¾</td>
            <td>8⅞</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>
              <strong>Centermeters (CM)</strong>
            </td>
            <td>79/81</td>
            <td>84/86</td>
            <td>89/91</td>
            <td>94/97</td>
            <td>79/81</td>
            <td>84/86</td>
            <td>89/91</td>
            <td>94/97</td>
            <td>94/97</td>
          </tr>
          <tr>
            <td>
              <strong>Inches</strong>
            </td>
            <td>31/32</td>
            <td>33/34</td>
            <td>35/36</td>
            <td>37/38</td>
            <td>31/32</td>
            <td>33/34</td>
            <td>35/36</td>
            <td>37/38</td>
            <td>37/38</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const sizeClothingAdidas = () => {
  return (
    <div className="size-guide-clothing">
      <table>
        <tbody>
          <tr>
            <th colSpan="22">
              <p>Adidas Footwear</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>UK</strong>
            </td>
            <td>3</td>
            <td>3.5</td>
            <td>4</td>
            <td>4.5</td>
            <td>5</td>
            <td>5.5</td>
            <td>6</td>
            <td>6.5</td>
            <td>7</td>
            <td>7.5</td>
            <td>8</td>
            <td>8.5</td>
            <td>9</td>
            <td>9.5</td>
            <td>10</td>
            <td>10.5</td>
            <td>11</td>
            <td>11.5</td>
            <td>12</td>
            <td>12.5</td>
            <td>13</td>
          </tr>
          <tr>
            <td>
              <strong>US</strong>
            </td>
            <td>3.5</td>
            <td>4</td>
            <td>4.5</td>
            <td>5</td>
            <td>5.5</td>
            <td>6</td>
            <td>6.5</td>
            <td>7</td>
            <td>7.5</td>
            <td>8</td>
            <td>8.5</td>
            <td>9</td>
            <td>9.5</td>
            <td>10</td>
            <td>10.5</td>
            <td>11</td>
            <td>11.5</td>
            <td>12</td>
            <td>12.5</td>
            <td>13</td>
            <td>13.5</td>
          </tr>
          <tr>
            <td>
              <strong>EU</strong>
            </td>
            <td>35.5</td>
            <td>36</td>
            <td>36.5</td>
            <td>37.5</td>
            <td>38</td>
            <td>38.5</td>
            <td>39 1/3</td>
            <td>40</td>
            <td>40 2/3</td>
            <td>41 1/3</td>
            <td>42</td>
            <td>42 2/3</td>
            <td>43 1/3</td>
            <td>44</td>
            <td>44 2/3</td>
            <td>45 1/3</td>
            <td>46</td>
            <td>46 2/3</td>
            <td>47 1/3</td>
            <td>48</td>
            <td>49 2/3</td>
          </tr>
          <tr>
            <td>
              <strong>Heel-Toe</strong>
            </td>
            <td>22.5</td>
            <td>23</td>
            <td>23.5</td>
            <td>23.5</td>
            <td>24</td>
            <td>24</td>
            <td>24.2</td>
            <td>24.6</td>
            <td>25</td>
            <td>25.5</td>
            <td>25.9</td>
            <td>26.3</td>
            <td>26.7</td>
            <td>27.1</td>
            <td>27.6</td>
            <td>28</td>
            <td>28.4</td>
            <td>28.8</td>
            <td>29.3</td>
            <td>29.7</td>
            <td>30.1</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const sizeClothingNike = () => {
  return (
    <div className="size-guide-clothing">
      <table>
        <tbody>
          <tr>
            <th colSpan="22">
              <p>Nike Footwear</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>UK</strong>
            </td>
            <td>3</td>
            <td>3.5</td>
            <td>4</td>
            <td>4.5</td>
            <td>5</td>
            <td>5.5</td>
            <td>6</td>
            <td>6.5</td>
            <td>7</td>
            <td>7.5</td>
            <td>8</td>
            <td>8.5</td>
            <td>9</td>
            <td>9.5</td>
            <td>10</td>
            <td>10.5</td>
            <td>11</td>
            <td>11.5</td>
            <td>12</td>
            <td>12.5</td>
            <td>13</td>
          </tr>
          <tr>
            <td>
              <strong>US</strong>
            </td>
            <td>3.5</td>
            <td>4</td>
            <td>4.5</td>
            <td>5</td>
            <td>5.5</td>
            <td>6</td>
            <td>6.5</td>
            <td>7.5</td>
            <td>8</td>
            <td>8.5</td>
            <td>9</td>
            <td>9.5</td>
            <td>10</td>
            <td>10.5</td>
            <td>11</td>
            <td>11.5</td>
            <td>12</td>
            <td>12.5</td>
            <td>12.5</td>
            <td>13.5</td>
            <td>14</td>
          </tr>
          <tr>
            <td>
              <strong>EU</strong>
            </td>
            <td>35.5</td>
            <td>36</td>
            <td>36.5</td>
            <td>37.5</td>
            <td>38</td>
            <td>38.5</td>
            <td>39</td>
            <td>40.5</td>
            <td>41</td>
            <td>42</td>
            <td>42.5</td>
            <td>43</td>
            <td>44</td>
            <td>44.5</td>
            <td>45</td>
            <td>45.5</td>
            <td>46</td>
            <td>46.5</td>
            <td>47</td>
            <td>47.5</td>
            <td>48</td>
          </tr>
          <tr>
            <td>
              <strong>CM</strong>
            </td>
            <td>22.5</td>
            <td>23</td>
            <td>23.5</td>
            <td>23.5</td>
            <td>24</td>
            <td>24</td>
            <td>24.5</td>
            <td>25.5</td>
            <td>26</td>
            <td>26.5</td>
            <td>27</td>
            <td>27.5</td>
            <td>28</td>
            <td>28.5</td>
            <td>29</td>
            <td>29.5</td>
            <td>30</td>
            <td>30.5</td>
            <td>31</td>
            <td>31.5</td>
            <td>32</td>
          </tr>
        </tbody>
      </table>
      {/* NIKE TOPS */}
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Nike Tops</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Size</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>Chest (CM)</strong>
            </td>
            <td>80-88</td>
            <td>88-96</td>
            <td>96-104</td>
            <td>104-112</td>
            <td>112-124</td>
            <td>124-136</td>
          </tr>
          <tr>
            <td>
              <strong>Waist (CM)</strong>
            </td>
            <td>65-73</td>
            <td>73-81</td>
            <td>81-89</td>
            <td>89-97</td>
            <td>97-109</td>
            <td>109-121</td>
          </tr>
          <tr>
            <td>
              <strong>Hip (CM)</strong>
            </td>
            <td>80-88</td>
            <td>88-96</td>
            <td>96-104</td>
            <td>104-112</td>
            <td>112-120</td>
            <td>120-128</td>
          </tr>
          <tr>
            <td>
              <strong>Height (CM)</strong>
            </td>
            <td>170-183</td>
            <td>170-183</td>
            <td>170-183</td>
            <td>170-183</td>
            <td>170-183</td>
            <td>170-183</td>
          </tr>
        </tbody>
      </table>
      {/* NIKE BOTTOMS */}
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Nike Bottoms</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Size</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>Waist (CM)</strong>
            </td>
            <td>&lt; 73</td>
            <td>73-81</td>
            <td>81-89</td>
            <td>89-97</td>
            <td>97-109</td>
            <td>109-121</td>
          </tr>
          <tr>
            <td>
              <strong>Hip (CM)</strong>
            </td>
            <td>&lt; 88</td>
            <td>88-96</td>
            <td>96-104</td>
            <td>104-112</td>
            <td>112-120</td>
            <td>120-128</td>
          </tr>
          <tr>
            <td>
              <strong>Leg Length (CM)</strong>
            </td>
            <td>&lt; 82.5</td>
            <td>82.5</td>
            <td>83</td>
            <td>83.5</td>
            <td>84</td>
            <td>84.5</td>
          </tr>
          <tr>
            <td>
              <strong>Height (CM)</strong>
            </td>
            <td>170-183</td>
            <td>170-183</td>
            <td>170-183</td>
            <td>170-183</td>
            <td>170-183</td>
            <td>170-183</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const sizeClothingNewBalance = () => {
  return (
    <div className="size-guide-clothing">
      <table>
        <tbody>
          <tr>
            <th colSpan="22">
              <p>New Balance Footwear</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>UK</strong>
            </td>
            <td>3</td>
            <td>3.5</td>
            <td>4</td>
            <td>4.5</td>
            <td>5</td>
            <td>5.5</td>
            <td>6</td>
            <td>6.5</td>
            <td>7</td>
            <td>7.5</td>
            <td>8</td>
            <td>8.5</td>
            <td>9</td>
            <td>9.5</td>
            <td>10</td>
            <td>10.5</td>
            <td>11</td>
            <td>11.5</td>
            <td>12</td>
            <td>12.5</td>
            <td>13</td>
          </tr>
          <tr>
            <td>
              <strong>US</strong>
            </td>
            <td>3.5</td>
            <td>4</td>
            <td>4.5</td>
            <td>5</td>
            <td>5.5</td>
            <td>6</td>
            <td>6.5</td>
            <td>7.5</td>
            <td>8</td>
            <td>8.5</td>
            <td>9</td>
            <td>9.5</td>
            <td>10</td>
            <td>10.5</td>
            <td>11</td>
            <td>11.5</td>
            <td>12</td>
            <td>12.5</td>
            <td>12.5</td>
            <td>13.5</td>
            <td>14</td>
          </tr>
          <tr>
            <td>
              <strong>EU</strong>
            </td>
            <td>36.5</td>
            <td>37</td>
            <td>37.5</td>
            <td>38</td>
            <td>38.5</td>
            <td>39</td>
            <td>39.5</td>
            <td>40</td>
            <td>40.5</td>
            <td>41.5</td>
            <td>42</td>
            <td>42.5</td>
            <td>43</td>
            <td>44</td>
            <td>44.5</td>
            <td>45</td>
            <td>45.5</td>
            <td>46.5</td>
            <td>47</td>
            <td>47.5</td>
            <td>48</td>
          </tr>
          <tr>
            <td>
              <strong>CM</strong>
            </td>
            <td>22.5</td>
            <td>23</td>
            <td>23.5</td>
            <td>23.5</td>
            <td>24</td>
            <td>24</td>
            <td>24.5</td>
            <td>25.5</td>
            <td>26</td>
            <td>26.5</td>
            <td>27</td>
            <td>27.5</td>
            <td>28</td>
            <td>28.5</td>
            <td>29</td>
            <td>29.5</td>
            <td>30</td>
            <td>30.5</td>
            <td>31</td>
            <td>31.5</td>
            <td>32</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const sizeClothingArctyrex = () => {
  return (
    <div className="size-guide-clothing">
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Arc'Teryx Tops &amp; Outerwear</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Size</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>Chest (CM)</strong>
            </td>
            <td>92</td>
            <td>97</td>
            <td>102</td>
            <td>110</td>
            <td>118</td>
            <td>128</td>
          </tr>
          <tr>
            <td>
              <strong>Sleeve (CM)</strong>
            </td>
            <td>81</td>
            <td>84</td>
            <td>86</td>
            <td>89</td>
            <td>91</td>
            <td>94</td>
          </tr>
          <tr>
            <td>
              <strong>Hip (CM)</strong>
            </td>
            <td>90</td>
            <td>95</td>
            <td>100</td>
            <td>108</td>
            <td>116</td>
            <td>126</td>
          </tr>
          <tr>
            <td>
              <strong>Waist (CM)</strong>
            </td>
            <td>76</td>
            <td>81</td>
            <td>86</td>
            <td>94</td>
            <td>102</td>
            <td>112</td>
          </tr>
        </tbody>
      </table>
      {/* ARCTERYX BOTTOMS */}
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Arc'Teryx Men's Bottoms</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Size</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>Waist</strong>
            </td>
            <td>30"</td>
            <td>32"</td>
            <td>34"</td>
            <td>37"</td>
            <td>40"</td>
            <td>44"</td>
          </tr>
          <tr>
            <td>
              <strong>Hip</strong>
            </td>
            <td>35" 1/2</td>
            <td>37" 1/2</td>
            <td>39" 1/2</td>
            <td>42" 1/2</td>
            <td>45" 1/2</td>
            <td>49" 1/2</td>
          </tr>
          <tr>
            <td>
              <strong>Regular Inseam</strong>
            </td>
            <td>31" 1/2</td>
            <td>32"</td>
            <td>32" 1/2</td>
            <td>33"</td>
            <td>33"</td>
            <td>33"</td>
          </tr>
          <tr>
            <td>
              <strong>Tall Inseam</strong>
            </td>
            <td>34" 1/2</td>
            <td>35"</td>
            <td>35"</td>
            <td>35" 1/2</td>
            <td>36"</td>
            <td>36"</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const sizeClothingCanada = () => {
  return (
    <div className="size-guide-clothing">
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Canada Goose Tops &amp; Outerwear</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Size</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>Chest (CM)</strong>
            </td>
            <td>86-89</td>
            <td>91-94</td>
            <td>97-102</td>
            <td>104-109</td>
            <td>112-117</td>
            <td>119-130</td>
          </tr>
          <tr>
            <td>
              <strong>Sleeve (CM)</strong>
            </td>
            <td>84-86</td>
            <td>85-88</td>
            <td>86-89</td>
            <td>88-90</td>
            <td>89-91</td>
            <td>90-93</td>
          </tr>
          <tr>
            <td>
              <strong>Hip (CM)</strong>
            </td>
            <td>86-89</td>
            <td>91-94</td>
            <td>97-102</td>
            <td>104-109</td>
            <td>112-117</td>
            <td>119-130</td>
          </tr>
          <tr>
            <td>
              <strong>Waist (CM)</strong>
            </td>
            <td>69-71</td>
            <td>74-76</td>
            <td>79-84</td>
            <td>86-91</td>
            <td>92-99</td>
            <td>102-112</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const sizeClothingCPCompany = () => {
  return (
    <div className="size-guide-clothing">
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>C.P. Company Tops &amp; Outerwear</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Size UK</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>EU</strong>
            </td>
            <td>46</td>
            <td>48</td>
            <td>50</td>
            <td>52</td>
            <td>54</td>
            <td>56</td>
          </tr>
          <tr>
            <td>
              <strong>Chest</strong>
            </td>
            <td>36"</td>
            <td>38"</td>
            <td>40"</td>
            <td>42"</td>
            <td>44"</td>
            <td>46"</td>
          </tr>
          <tr>
            <td>
              <strong>Sleeve (CM)</strong>
            </td>
            <td>82-83.5</td>
            <td>84-85.5</td>
            <td>85.5-87</td>
            <td>87-89</td>
            <td>89-90.5</td>
            <td>90.5-92</td>
          </tr>
        </tbody>
      </table>
      {/* CP COMPANY BOTTOMS */}
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>C.P. Company Bottoms</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Size UK</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>EU</strong>
            </td>
            <td>46</td>
            <td>48</td>
            <td>50</td>
            <td>52</td>
            <td>54</td>
            <td>56</td>
          </tr>
          <tr>
            <td>
              <strong>Waist</strong>
            </td>
            <td>30"</td>
            <td>32"</td>
            <td>34"</td>
            <td>36"</td>
            <td>38"</td>
            <td>40"</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const sizeClothingMoncler = () => {
  return (
    <div className="size-guide-clothing">
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Moncler Tops &amp; Outerwear</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Size UK</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>Italian</strong>
            </td>
            <td>0</td>
            <td>1</td>
            <td>2</td>
            <td>3</td>
            <td>4</td>
            <td>5</td>
          </tr>
          <tr>
            <td>
              <strong>Chest (CM)</strong>
            </td>
            <td>88</td>
            <td>92</td>
            <td>96</td>
            <td>100</td>
            <td>102</td>
            <td>104</td>
          </tr>
          <tr>
            <td>
              <strong>Height (CM)</strong>
            </td>
            <td>172</td>
            <td>176</td>
            <td>178</td>
            <td>180</td>
            <td>182</td>
            <td>184</td>
          </tr>
          <tr>
            <td>
              <strong>Waist (CM)</strong>
            </td>
            <td>76</td>
            <td>80</td>
            <td>84</td>
            <td>88</td>
            <td>94</td>
            <td>100</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Moncler Bottoms</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Size UK</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>Italian</strong>
            </td>
            <td>0</td>
            <td>1</td>
            <td>2</td>
            <td>3</td>
            <td>4</td>
            <td>5</td>
          </tr>
          <tr>
            <td>
              <strong>Waist (CM)</strong>
            </td>
            <td>76</td>
            <td>80</td>
            <td>84</td>
            <td>88</td>
            <td>94</td>
            <td>100</td>
          </tr>
          <tr>
            <td>
              <strong>Hip (CM)</strong>
            </td>
            <td>92</td>
            <td>96</td>
            <td>100</td>
            <td>104</td>
            <td>110</td>
            <td>116</td>
          </tr>
          <tr>
            <td>
              <strong>Inner Leg (CM)</strong>
            </td>
            <td>76</td>
            <td>77</td>
            <td>78</td>
            <td>79</td>
            <td>80</td>
            <td>81</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const sizeClothingIssey = () => {
  return (
    <div className="size-guide-clothing">
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Issey Miyake Tops</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Size</strong>
            </td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
          </tr>
          <tr>
            <td>
              <strong>Japan</strong>
            </td>
            <td>01</td>
            <td>02</td>
            <td>03</td>
            <td>04</td>
          </tr>
          <tr>
            <td>
              <strong>Height (CM)</strong>
            </td>
            <td>60</td>
            <td>63</td>
            <td>65</td>
            <td>67</td>
          </tr>
          <tr>
            <td>
              <strong>Chest (CM)</strong>
            </td>
            <td>40</td>
            <td>42</td>
            <td>44</td>
            <td>46</td>
          </tr>
          <tr>
            <td>
              <strong>Shoulder (CM)</strong>
            </td>
            <td>40</td>
            <td>42</td>
            <td>44</td>
            <td>46</td>
          </tr>
        </tbody>
      </table>
      {/* ISSEY MIYAKE BOTTOMS */}
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Issey Miyake Bottoms</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Size</strong>
            </td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
          </tr>
          <tr>
            <td>
              <strong>Japan</strong>
            </td>
            <td>01</td>
            <td>02</td>
            <td>03</td>
            <td>04</td>
          </tr>
          <tr>
            <td>
              <strong>Waist (CM)</strong>
            </td>
            <td>74</td>
            <td>78</td>
            <td>82</td>
            <td>86</td>
          </tr>
          <tr>
            <td>
              <strong>Inside Leg (CM)</strong>
            </td>
            <td>68</td>
            <td>70</td>
            <td>71</td>
            <td>72</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const sizeClothingCDG = () => {
  return (
    <div className="size-guide-clothing">
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Mens Outerwear</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Japanese</strong>
            </td>
            <td>0</td>
            <td>1</td>
            <td>2</td>
            <td>3</td>
            <td>4</td>
            <td>5</td>
          </tr>
          <tr>
            <td>
              <strong>Size</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>Centermeters (CM)</strong>
            </td>
            <td>86/89</td>
            <td>90/96</td>
            <td>98/102</td>
            <td>104/109</td>
            <td>112/117</td>
            <td>119/123</td>
          </tr>
          <tr>
            <td>
              <strong>Inches</strong>
            </td>
            <td>35/36</td>
            <td>37/38</td>
            <td>39/40</td>
            <td>41/42</td>
            <td>43/44</td>
            <td>45/46</td>
          </tr>
        </tbody>
      </table>
      {/* Mens Tops */}
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Mens Tops</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Japanese</strong>
            </td>
            <td>0</td>
            <td>1</td>
            <td>2</td>
            <td>3</td>
            <td>4</td>
            <td>5</td>
          </tr>
          <tr>
            <td>
              <strong>Size</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>Centermeters (CM)</strong>
            </td>
            <td>86/89</td>
            <td>90/96</td>
            <td>98/102</td>
            <td>104/109</td>
            <td>112/117</td>
            <td>118/123</td>
          </tr>
          <tr>
            <td>
              <strong>Inches</strong>
            </td>
            <td>35/36</td>
            <td>37/38</td>
            <td>39/40</td>
            <td>41/42</td>
            <td>43/44</td>
            <td>45/46</td>
          </tr>
        </tbody>
      </table>
      {/* Mens Bottoms */}
      <table>
        <tbody>
          <tr>
            <th colSpan="7">
              <p>Mens Bottoms</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Japanese</strong>
            </td>
            <td>0</td>
            <td>1</td>
            <td>2</td>
            <td>3</td>
            <td>4</td>
            <td>5</td>
          </tr>
          <tr>
            <td>
              <strong>Size</strong>
            </td>
            <td>XS</td>
            <td>S</td>
            <td>M</td>
            <td>L</td>
            <td>XL</td>
            <td>XXL</td>
          </tr>
          <tr>
            <td>
              <strong>Centermeters (CM)</strong>
            </td>
            <td>73/76</td>
            <td>77/80</td>
            <td>81/84</td>
            <td>84/86</td>
            <td>87/90</td>
            <td>91/94</td>
          </tr>
          <tr>
            <td>
              <strong>Inches</strong>
            </td>
            <td>28/29</td>
            <td>30/31</td>
            <td>32/33</td>
            <td>33/34</td>
            <td>35/36</td>
            <td>37/38</td>
          </tr>
        </tbody>
      </table>
      {/* Fitted Caps */}
      <table>
        <tbody>
          <tr>
            <th colSpan="10">
              <p>Fitted Caps</p>
            </th>
          </tr>
          <tr>
            <td>
              <strong>Cap</strong>
            </td>
            <td>6⅞</td>
            <td>7</td>
            <td>7⅛</td>
            <td>7⅜</td>
            <td>7½</td>
            <td>7⅝</td>
            <td>7¾</td>
            <td>8⅞</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td>
              <strong>Centermeters (CM)</strong>
            </td>
            <td>79/81</td>
            <td>84/86</td>
            <td>89/91</td>
            <td>94/97</td>
            <td>79/81</td>
            <td>84/86</td>
            <td>89/91</td>
            <td>94/97</td>
            <td>94/97</td>
          </tr>
          <tr>
            <td>
              <strong>Inches</strong>
            </td>
            <td>31/32</td>
            <td>33/34</td>
            <td>35/36</td>
            <td>37/38</td>
            <td>31/32</td>
            <td>33/34</td>
            <td>35/36</td>
            <td>37/38</td>
            <td>37/38</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export const mapRegionName = [
  { name: 'UK' },
  { name: 'Japanese' },
  { name: 'European' }
];

export const mapBrandName = [
  { name: 'Adidas' },
  { name: 'Nike' },
  { name: 'New Balance' },
  { name: 'Arctyrex' },
  { name: 'Canada Goose' },
  { name: 'CP Company' },
  { name: 'Homme Plisse Issey Miyake' },
  { name: 'Moncler' },
  { name: 'Commes Des Garcons' }
];

export const mapRegions = [
  { region: sizeClothingUK() },
  { region: sizeClothingJapan() },
  { region: sizeClothingEU() }
];

export const mapBrands = [
  { brand: sizeClothingAdidas() },
  { brand: sizeClothingNike() },
  { brand: sizeClothingNewBalance() },
  { brand: sizeClothingArctyrex() },
  { brand: sizeClothingCanada() },
  { brand: sizeClothingCPCompany() },
  { brand: sizeClothingIssey() },
  { brand: sizeClothingMoncler() },
  { brand: sizeClothingCDG() }
];

// SIZES DATA - FOOTWEAR
export const sizeListUK = [
  { number: 1, alt: '1' },
  { number: 2, alt: '2' },
  { number: 3, alt: '3' },
  { number: 4, alt: '4' },
  { number: 5, alt: '5' },
  { number: 6, alt: '6' },
  { number: 7, alt: '7' },
  { number: 8, alt: '8' },
  { number: 9, alt: '9' },
  { number: 10, alt: '10' },
  { number: 11, alt: '11' },
  { number: 12, alt: '12' }
];

export const sizeListUS = [
  { number: 2, alt: '2' },
  { number: 3, alt: '3' },
  { number: 4, alt: '4' },
  { number: 5, alt: '5' },
  { number: 6, alt: '6' },
  { number: 7, alt: '7' },
  { number: 8, alt: '8' },
  { number: 9, alt: '9' },
  { number: 10, alt: '10' },
  { number: 11, alt: '11' },
  { number: 12, alt: '12' },
  { number: 13, alt: '13' }
];

export const sizeListEU = [
  { number: 35, alt: '35' },
  { number: 36, alt: '36' },
  { number: 37, alt: '37' },
  { number: 38, alt: '38' },
  { number: 39, alt: '39' },
  { number: 40, alt: '40' },
  { number: 41, alt: '41' },
  { number: 42, alt: '42' },
  { number: 43, alt: '43' },
  { number: 44, alt: '44' },
  { number: 45, alt: '45' },
  { number: 46, alt: '46' }
];

export const sizeListCM = [
  { number: 23, alt: '23' },
  { number: 23.5, alt: '23.5' },
  { number: 24.5, alt: '24.5' },
  { number: 25, alt: '25' },
  { number: 25.5, alt: '25.5' },
  { number: 26, alt: '26' },
  { number: 27, alt: '27' },
  { number: 27.5, alt: '27.5' },
  { number: 28, alt: '28' },
  { number: 28.5, alt: '28.5' },
  { number: 29, alt: '29' },
  { number: 29.5, alt: '29.5' }
];
